var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};
var site = site || {};

site.client = site.client || {};
site.direction = site.direction || {};

(function ($) {
  $(document).on(
    'product.skuDisplay',
    '.js-product',
    _.debounce(function (e, skuBaseId) {
      if (Unison.fetch.now() && Unison.fetch.now().name !== 'small') {
        var $swatchGallery = $('.js-swatch-gallery', $(this));

        Drupal.behaviors.shadeDotFamiliesV1.displaySkuImage($swatchGallery, skuBaseId);
      }
    }, 100)
  );
  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId) {
    var $gallery = $('.js-swatch-gallery', $(this));

    if ($gallery.length < 1) {
      return null;
    }
    if (Unison.fetch.now() && Unison.fetch.now().name === 'small') {
      Drupal.behaviors.shadeDotFamiliesV1.displaySkuAltImageMobile($gallery, skuBaseId);
    } else {
      Drupal.behaviors.shadeDotFamiliesV1.displaySkuAltImage($gallery, skuBaseId);
    }
  });
  Drupal.behaviors.shadeDotFamiliesV1 = {
    hideSmoosh: false,
    skuAltImage: null,
    attached: false,
    attach: function (context, settings) {
      if (settings && settings.bb_product) {
        this.hideSmoosh = settings.bb_product.spp_hide_smoosh;
      }
      if (this.attached) {
        return;
      }
      this.attached = true;
      this.initColorFamilies($('.js-shade-dot-filter', context));
      this.initThumbnailCarousel($('.js-swatch-gallery', context));
      if (Unison.fetch.now() && Unison.fetch.now().name === 'small') {
        var $setHeight = $('.swatch-gallery').width();

        $('.swatch-gallery__slider').css('height', $setHeight);
      }
      $('.js-shade-dot-filter').each(function (context) {
        var $skuCategory = $('.js-color-families', context).find(
          '.resp-tab-content-active .js-swatch-list li:first .js-swatch-list-item-link'
        );

        $skuCategory.trigger('click');
      });
    },
    initColorFamilies: function () {
      $('.js-shade-dot-filter').each(function (context) {
        var $this = $(this);
        var $wrap = $this.find('.js-color-families', context);
        var prodId = $wrap.data('product-id');
        var prodData = prodcat.data.getProduct(prodId);
        var colorFamilies = _.filter(prodData.skus, function (sku) {
          return !!sku['ATTRIBUTE_COLOR_FAMILY'];
        });
        var collections = _.groupBy(colorFamilies, 'ATTRIBUTE_COLOR_FAMILY');
        var $tabsList = $this.find('.js-color-families-tabs', context);
        var $contents = $this.find('.js-color-families-content', context);

        if (!prodId) {
          return null;
        }
        if (!prodData) {
          return null;
        }
        if (colorFamilies.length > 1) {
          // There is only one tab in this case, so give it the active tab class, and exit
          $this.find('.js-color-families-tabs').removeClass('hide-tabs');
        }
        _.each(collections, function (collection, key) {
          var tabHtml = '<li class="js-color-families-tab color-families-nav-item">';

          tabHtml += key;
          tabHtml += '</li>';
          $tabsList.append(tabHtml);
          var contentHtml = '<div>';
          var swatchListHtml = site.template.get({
            name: 'swatch_list_v1',
            data: {
              PRODUCT_ID: prodId,
              skus: collection
            }
          });

          contentHtml += swatchListHtml;
          contentHtml += '</div>';
          $contents.append(contentHtml);
        });
        $wrap.easyResponsiveTabs();
      });
      // Below code is to select the first sku by default when clicking on each tab.
      $('.js-color-families-tab').click(function (context) {
        var $this = $(this);
        var uri = window.location.toString();
        var clean_uri = uri.substring(0, uri.indexOf('#'));

        window.history.replaceState({}, document.title, clean_uri);
        var $skuCategory = $this
          .closest('.js-color-families')
          .find('.resp-tab-content-active .js-swatch-list li:first .js-swatch-list-item-link');

        $skuCategory.trigger('click');
      });
    },
    displaySkuImage: function ($gallery, skuBaseId) {
      var $skuData = prodcat.data.getSku(skuBaseId);
      var $prodID = $skuData.PRODUCT_ID;
      var $thumbnail_gallery = $('.js-swatch-gallery[data-product-id = ' + $prodID + ']');
      var thumbnailImg_default = $thumbnail_gallery.data('default-image') - 2;
      var thumbnail_default = $thumbnail_gallery.data('default-image') - 1;
      isProductImageResponsive =
        Drupal.settings.global_variables &&
        Drupal.settings.global_variables.product_responsive_images;
      productImageLargeField = isProductImageResponsive ? 'IMAGE_LARGE' : 'IMAGE_L_V2';

      $('.swatch-gallery__slider').slickGoTo(thumbnail_default); // hack to fix bug with slick slider.
      $thumbnail_gallery
        .find(
          '.js-swatch-gallery__div-photo--product[data-gallery-index = ' + thumbnail_default + ']'
        )
        .find('.js-swatch-gallery__photo--product', $gallery)
        .attr('src', $skuData[productImageLargeField][thumbnailImg_default]);
    },
    displaySkuAltImage: function ($gallery, skuBaseId, urlhit) {
      var skuData = prodcat.data.getSku(skuBaseId);
      var prodID = skuData.PRODUCT_ID;
      var $prodImageContainer = $('.js-swatch-gallery[data-product-id = ' + prodID + ']').find(
        '.swatch-gallery__slider',
        $gallery
      );
      var prodData = prodcat.data.getProduct(skuData.PRODUCT_ID);
      var skuAltImageCount = skuData.NUMBER_OF_ALT_IMAGES;
      var productAltImages = prodData.NUMBER_OF_ALT_IMAGES;
      var allProdImages = [];
      var productImages = [];
      var skuImages = [];
      var thumbBaseImage = '';
      var className = '';
      var thumbAltClass = '';
      var isSkuBaseImage = false;
      var index_position = '';
      var i = 1;
      var j = 1;

      // Sku level base image
      isProductImageResponsive =
        Drupal.settings.global_variables &&
        Drupal.settings.global_variables.product_responsive_images;
      productImageLargeField = isProductImageResponsive ? 'IMAGE_LARGE' : 'IMAGE_L_V2';
      if (skuData.productImageLargeField2) {
        skuImages['L'] = skuData[productImageLargeField][0];
        isSkuBaseImage = true;
        thumbBaseImage = skuData[productImageLargeField][0];
        allProdImages.push(skuImages);
        // Sku level Alt images
        for (i = 1; i <= skuAltImageCount; i++) {
          skuImages = [];
          skuImages['L'] = skuData[productImageLargeField][i];
          allProdImages.push(skuImages);
        }
      } else {
        // Prod level Base image
        allProdImages.push(prodData['IMAGE_L'][0]);
        thumbBaseImage = prodData.IMAGE_L[0];
      }
      // Prod level Alt images
      for (j = 1; j <= productAltImages; j++) {
        productImages = [];
        productImages['L'] = prodData['IMAGE_L'][j];
        allProdImages.push(productImages);
      }
      if (prodData.shaded) {
        productImages = [];
        productImages['L'] = skuData['IMAGE_LARGE_COMBINED'][1];
      }
      allProdImages.splice(1, 0, productImages);
      $prodImageContainer.empty().add($prodImageContainer).removeClass('slick-initialized');
      $(allProdImages).each(function (index, images) {
        if (images['L'] && images['L'].indexOf('bb_smoosh') > 1) {
          className = 'smoosh';
        } else if (index > 1) {
          className = 'product swatch-gallery__photo--large-alt';
          thumbAltClass = ' swatch-gallery__slide-alt';
        } else {
          className = 'product';
        }
        var $largeImage = $('<img>', {
          class: 'js-gallery-img-large js-swatch-gallery__photo--' + className + ' fluid-image ',
          src: images.L
        })
          .attr('alt', prodData.PROD_RGN_NAME)
          .attr('data-gallery-index', index);
        var $productImageWrapper = $('<div/>', {
          class: 'swatch-gallery__slide js-swatch-gallery__div-photo--' + className + thumbAltClass,
          html: $largeImage
        }).attr('data-gallery-index', index);

        if (urlhit || !isSkuBaseImage) {
          index_position = 2;
        }
        if (index === index_position) {
          $productImageWrapper.addClass('active');
          $largeImage.addClass('active');
        }
        $prodImageContainer.append($productImageWrapper);
      });
      this.initThumbnailCarousel($('.js-swatch-gallery', $gallery));
    },
    displaySkuAltImageMobile: function ($gallery, skuBaseId, urlhit) {
      var skuData = prodcat.data.getSku(skuBaseId);
      var prodID = skuData.PRODUCT_ID;
      var $thumbnail_gallery = $('.js-swatch-gallery[data-product-id = ' + prodID + ']');
      var thumbnailImg_default = $thumbnail_gallery.data('default-image') - 2;
      var $prodImageContainer = $('.js-swatch-gallery[data-product-id = ' + prodID + ']').find(
        '.swatch-gallery__slider',
        $gallery
      );
      var prodData = prodcat.data.getProduct(skuData.PRODUCT_ID);
      var skuAltImageCount = 1;
      var productAltImages = prodData.NUMBER_OF_ALT_IMAGES;
      var allProdImages = [];
      var productImages = [];
      var skuImages = [];
      var thumbBaseImage = '';
      var className = '';
      var thumbAltClass = '';
      var isSkuBaseImage = false;
      var index_position = '';
      var i = thumbnailImg_default;
      var j = 1;

      // Sku level base image
      isProductImageResponsive =
        Drupal.settings.global_variables &&
        Drupal.settings.global_variables.product_responsive_images;
      productImageLargeField = isProductImageResponsive ? 'IMAGE_LARGE' : 'IMAGE_L_V2';
      if (skuData[productImageLargeField]) {
        skuImages['L'] = skuData[productImageLargeField][0];
        isSkuBaseImage = true;
        thumbBaseImage = skuData[productImageLargeField][0];
        allProdImages.push(skuImages);
        // Sku level Alt images
        for (i = 1; i <= skuAltImageCount; i++) {
          skuImages = [];
          skuImages['L'] = skuData[productImageLargeField][thumbnailImg_default];
          allProdImages.push(skuImages);
        }
      } else {
        // Prod level Base image
        allProdImages.push(prodData['IMAGE_L'][0]);
        thumbBaseImage = prodData.IMAGE_L[0];
      }
      // Prod level Alt images
      for (j = 1; j <= productAltImages; j++) {
        productImages = [];
        productImages['L'] = prodData['IMAGE_L'][j];
        allProdImages.push(productImages);
      }
      if (prodData.shaded) {
        productImages = [];
        productImages['L'] = skuData['IMAGE_SMOOSH_XL'][0];
      }
      allProdImages.splice(1, 0, productImages);
      $prodImageContainer.empty().add($prodImageContainer).removeClass('slick-initialized');
      $(allProdImages).each(function (index, images) {
        if (images['L'] && images['L'].indexOf('bb_smoosh') > 1) {
          className = 'smoosh';
        } else if (index > 1) {
          className = 'product swatch-gallery__photo--large-alt';
          thumbAltClass = ' swatch-gallery__slide-alt';
        } else {
          className = 'product';
        }
        var $largeImage = $('<img>', {
          class: 'js-gallery-img-large js-swatch-gallery__photo--' + className + ' fluid-image ',
          src: images.L
        })
          .attr('alt', prodData.PROD_RGN_NAME)
          .attr('data-gallery-index', index)
          .attr({
            width: 415,
            height: 415
          });
        var $productImageWrapper = $('<div/>', {
          class: 'swatch-gallery__slide js-swatch-gallery__div-photo--' + className + thumbAltClass,
          html: $largeImage
        }).attr('data-gallery-index', index);

        if (index === index_position) {
          $productImageWrapper.addClass('active');
          $largeImage.addClass('active');
        }
        $prodImageContainer.append($productImageWrapper);
      });
      this.initThumbnailCarousel($('.js-swatch-gallery', $gallery));
    },
    initThumbnailCarousel: function ($gallery, context) {
      var $thumbnail_array = $('.swatch-gallery__slide', context);
      var $thumbnail_gallery = $('.js-shade-dot-filter').find('.swatch-gallery__slider', context);
      var thumbnail_default = $thumbnail_gallery.data('default-image') - 1;

      if ($thumbnail_array.length > 1) {
        $thumbnail_gallery.slick({
          rtl: site.direction.isRTL,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 1,
          fade: true,
          cssEase: 'linear'
        });
        if (Unison.fetch.now() && Unison.fetch.now().name === 'small') {
          $thumbnail_gallery.slickGoTo(2); // hack to fix bug with slick slider.
        } else {
          $thumbnail_gallery.slickGoTo(thumbnail_default); // hack to fix bug with slick slider.
        }
      }
    }
  }; // end Drupal.behaviors.shadeDotFamiliesV1
})(jQuery);
